export default __webpack_public_path__ + "f5c118f69fd5997a07522634a2b42e51.png";